import axios from 'axios'
import moment from 'moment'
import AscentiaService from './ascentiaService'

const values = {
  derivedParameter: null,
  logicString: null,
}

const getters = {
  derivedParameters(parameterData) {
    let url = `/cpl/DerivedParameter`
    return axios.get(url, { params: parameterData })
  },
  derivedParameter(parameterID) {
    const url = `/cpl/DerivedParameter/${parameterID}`
    return axios.get(url)
  },

  derivedParamFlightData(flightOpts) {
    const flightPhaseUrl =
      flightOpts.flightPhase === 0
        ? ''
        : `&flightMode=${flightOpts.flightPhase}`

    let url = `/cpl/DerivedParameter/${flightOpts.parameter}/Airline/${flightOpts.airline}/TailNumber/${flightOpts.aircraft}/Data?numFlights=${flightOpts.flightNum}${flightPhaseUrl}`

    if (flightOpts.deptDate?.dates?.startDate) {
      url +=
        '&end=' + moment(flightOpts.deptDate.dates.startDate).format('YYYYMMDD')
    }
    return axios.get(url)
  },
}

const saves = {
  saveParameter(derivedParameter) {
    if (derivedParameter.id) {
      return axios.put(
        `/cpl/DerivedParameter/${derivedParameter.id}`,
        derivedParameter,
      )
    } else {
      return axios.post(`/cpl/DerivedParameter`, derivedParameter)
    }
  },
  parameterNameValidation(derivedParameterObj) {
    const url = `/cpl/DerivedParameter/Validate`
    return axios.post(url, {
      airlineId: derivedParameterObj.airlineId,
      name: derivedParameterObj.parameterName,
    })
  },
}

const deletes = {
  derivedParameter(ParameterIds) {
    let Ids = ''
    ParameterIds.forEach(Id => {
      Ids += `&ids=${Id}`
    })
    return axios.delete(`/cpl/DerivedParameter/ids?${Ids}`)
  },
}

export default class DerivedParametersService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
